import { useEffect, useState } from 'react';
import { addMinutes } from 'date-fns';

export function getTimeLeft(duration: number) {
  let timeLeft = new Date(duration);

  timeLeft = addMinutes(timeLeft, timeLeft.getTimezoneOffset());

  return timeLeft;
}

interface UseCountDownArgs {
  from: number;
  to: number;
  amountToSubtract: number;
  /**
   * @default 1000
   */
  intervalMs?: number;
}

export function useCountDown({ from, to, amountToSubtract, intervalMs = 1000 }: UseCountDownArgs): number {
  const [result, setResult] = useState(from);

  useEffect(() => {
    const interval = setInterval(() => {
      setResult((prevState) => {
        const newCount = prevState - amountToSubtract;

        if (newCount < to) {
          clearInterval(interval);

          return prevState;
        }

        return newCount;
      });
    }, intervalMs);

    return () => {
      clearInterval(interval);
    };
  }, [amountToSubtract, intervalMs, to]);

  useEffect(() => {
    setResult(from);
  }, [from]);

  return result;
}
